import * as React from "react";

function SvgSlack(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 126 126"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...{ ...props, ref }}
    >
      <defs>
        <path id="Slack_svg__a" d="M0 .313h438.872V125.94H0" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="Slack_svg__b" fill="#fff">
          <use xlinkHref="#Slack_svg__a" />
        </mask>
        <path
          d="M79.092 11.548c-1.854-5.707-7.983-8.83-13.689-6.975-5.707 1.854-8.83 7.983-6.975 13.689l28.092 86.432c1.929 5.331 7.688 8.327 13.216 6.736 5.766-1.66 9.281-7.784 7.441-13.447L79.092 11.548"
          fill="#DFA22F"
          mask="url(#Slack_svg__b)"
        />
        <path
          d="M35.564 25.691c-1.855-5.706-7.984-8.829-13.69-6.975-5.707 1.854-8.83 7.983-6.975 13.69l28.092 86.432c1.929 5.331 7.688 8.327 13.216 6.735 5.766-1.659 9.281-7.783 7.441-13.447L35.564 25.691"
          fill="#3CB187"
          mask="url(#Slack_svg__b)"
        />
        <path
          d="M114.452 83.131c5.707-1.854 8.829-7.983 6.975-13.69-1.854-5.706-7.983-8.829-13.689-6.975L21.306 90.559c-5.331 1.928-8.327 7.687-6.736 13.215 1.66 5.766 7.784 9.281 13.447 7.441l86.435-28.084"
          fill="#CE1E5B"
        />
        <path
          d="M39.32 107.543l20.658-6.712-6.713-20.66-20.659 6.715 6.714 20.657"
          fill="#392538"
        />
        <g>
          <path
            d="M82.849 93.399l20.658-6.712-6.714-20.664-20.659 6.715 6.715 20.661"
            fill="#BB242A"
          />
          <path
            d="M100.309 39.602c5.706-1.854 8.829-7.983 6.975-13.69-1.854-5.706-7.983-8.829-13.69-6.975L7.162 47.03C1.831 48.958-1.165 54.717.427 60.245c1.659 5.766 7.783 9.281 13.447 7.441l86.435-28.084"
            fill="#72C5CD"
          />
        </g>
        <path
          d="M25.173 64.015l20.661-6.713-6.712-20.66-20.664 6.716 6.715 20.657"
          fill="#248C73"
        />
        <path
          d="M68.701 49.872a160137.8 160137.8 0 0020.662-6.714l-6.714-20.664-20.663 6.716 6.715 20.662"
          fill="#62803A"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSlack);
